import {useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form'
import AlertConfirmModal from '../../../common/AlertConfirmModal';
import moment from 'moment'
import Spinner from 'react-bootstrap/Spinner'
import Pagination from 'react-bootstrap/Pagination'
import Badge from 'react-bootstrap/Badge'
import currency from 'currency.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './style.scss'

const PriceChanges = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [status, setStatus] = useState(false)
  const [show, setShow] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [mails, setMails] = useState([])
  const [priceChanges, setPriceChanges] = useState([])
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(25)
  const [sort, setSort] = useState('desc')
  const [orderBy, setOrderBy] = useState('id')
  const [total, setTotal] = useState(0)
  const [stats, setStats] = useState({})
  const [keyword, setKeyword] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [activePriceChange, setActivePriceChange] = useState({})
  const [busyRow, setBusyRow] = useState('')
  const [statusCheck, setStatusCheck] = useState(false)
  const [filters, setFilters] = useState({
    0: true,
    1: true,
    2: true
  })

  const getPriceChange = () => {
    setIsLoading(true)
    if (keyword) {
      setIsSearching(true)
    }
    
    let tmp = Object.keys(filters).filter(filter => {
      if (filters[filter]) {
        return filter
      }
    })

    axios.get(`/api/administration/crons/price-changes`, {
      params: {
        page,
        per_page: perPage,
        sort,
        order_by: orderBy,
        keyword,
        only: tmp.join(',')
      }
    })
      .then(response => {
        setPriceChanges(response.data.data)
        setTotal(response.data.total)
        setIsLoading(false)
        setIsSearching(false)
      })
      .catch(error => {
        setIsLoading(false)
        setIsSearching(false)
      })
  }

  const checkStatus = () => {
    setStatusCheck(true)
    axios.get(`/api/administration/crons/price-changes/status`)
      .then(response => {
        console.log('response: ', response.data)
        setStatus(response.data.status)
        setIsLoading(false)
        setStatusCheck(false)
      })
      .catch(error => {
        console.log({ error })
        setIsLoading(false)
        setStatusCheck(false)
      })
  }

  const getPriceChangeStatus = () => {
    setIsLoading(true)
    checkStatus()
  }

  const getPriceChangeStats = () => {
    setIsLoading(true)
    axios.get(`/api/administration/crons/price-changes/stats`)
      .then(response => {
        setStats(response.data)
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getPriceChangeStatus();
    getPriceChangeStats();
    getPriceChange();

    setInterval(checkStatus, 40000)
  }, [])

  const handleChange = (e) => {
    setShow(true)
    setIsLoading(true)
    axios.put('/api/administration/crons/price-changes', {
        status: status == 3 ? true : false
      })
      .then(response => {
        setIsLoading(false)
        setConfirm(false)
        setShow(false)
        setStatus(status != 3 ? 3 : 0)
      })
      .catch(error => {
        setIsLoading(false)
        setConfirm(false)
        setShow(false)
      })

    setStatus(status => !status)
  }

  const handleConfirm = () => {
    setConfirm(true)
    setShow(false)
  }

  useEffect(() => {
    if (confirm) {
      handleChange()
    }
  }, [confirm])

  useEffect(() => {
    // console.log(filters)
    getPriceChange()
  }, [orderBy, sort, page, filters])

  const handleOrder = (e, column) => {
    e.preventDefault()
    if (column == orderBy) {
      if (sort == 'asc') {
        setSort('desc')
      } else {
        setSort('asc')
      }
    } else {
      setSort('asc')
    }
    setOrderBy(column)
  }
  
  const handleManualPage = e => {
    let value = Number.isInteger(parseInt(e.target.value.trim())) && parseInt(e.target.value.trim()) > 0
    ? parseInt(e.target.value.trim())
    : page

    setPage(value);
  }

  const handlePrevPage = () => {
    setPage(page => page - 1)
  }

  const handleFirstPage = () => {
    setPage(1)
  }

  const handleNextPage = () => {
    setPage(page => page + 1)
  }

  const handleLastPage = () => {
    setPage(page => Math.ceil(total/perPage))
  }

  const Paginator = () => {
    return <Pagination
      style={{ justifyContent: "flex-end", alignItems: "center" }}
    >
          <span className="mr-3">
              {total} item{total > 1 ? "s" : ""}
          </span>
          <Pagination.First
              disabled={page > 1 ? false : true}
              className="mr-1"
              onClick={handleFirstPage}
          />
          <Pagination.Prev
              disabled={page > 1 ? false : true}
              onClick={handlePrevPage}
          />
          <div className="mx-2 d-flex flex-row align-items-center justify-content-center w-auto">
              <div className="mr-1" style={{ width: 35 }}>
                  <input
                      type="text"
                      className="pagination-input"
                      onChange={handleManualPage}
                      value={page}
                  />
              </div>
              of {Math.ceil(total/perPage)}
          </div>
          <Pagination.Next
              disabled={page < Math.ceil(total/perPage) ? false : true}
              onClick={handleNextPage}
          />
          <Pagination.Last
              disabled={page < Math.ceil(total/perPage) ? false : true}
              className="ml-1"
              onClick={handleLastPage}
          />
      </Pagination>
  }

  const handleConfirmDelete = (e, priceChange) => {
    setShowDelete(true)
    setActivePriceChange(priceChange)
  }

  const handleDelete = async () => {
    setIsLoading(true)
    setBusyRow(activePriceChange.id)
    await axios.delete(`/api/administration/crons/price-changes/${activePriceChange.id}`)
      .then(response => {
        getPriceChange()
        setIsLoading(false)
        setIsSearching(false)
        setActivePriceChange({})
        setShowDelete(false)
        setBusyRow('')
      })
      .catch(error => {
        setIsLoading(false)
        setIsSearching(false)
        setShowDelete(false)
        setBusyRow('')
        console.error({error})
      })
  }

  const handleResend = async (e, priceChange) => {
    e.preventDefault()
    setBusyRow(priceChange.id)

    setIsLoading(true)
    await axios.put(`/api/administration/crons/price-changes/resend`, {
      id: priceChange.id
    })
      .then(response => {
        getPriceChange()
        setIsLoading(false)
        setBusyRow('')
      })
      .catch(error => {
        setIsLoading(false)
        setBusyRow('')
        console.error({error})
      })
  }

  const handleSwitchChange = (e) => {
    // e.preventDefault()
    let tmpFilters = {...filters}
    tmpFilters = {
      ...tmpFilters,
      [e.target.value]: ! filters[e.target.value]
    }

    setFilters({...tmpFilters})

    console.log({filters})
  }

  useEffect(() => {
    setPage(1)
  }, [filters])

  const clearSearchText = () => {
    setKeyword('');
  }

  return (
    <div className="admin-price-changes">
      <div className="alert alert-info px-8 py-2">
        This CRON is ran every minute. If the CRON action is <b>waiting</b>, the system is not processing any price change or there are no pending price change to process. If CRON is <b>processing</b>, the system is processing subscription price change. If CRON action is <b>error</b>, you can toggle the CRON status switch button to reset the action to waiting.
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="text-left my-2">
            <span className="mr-2">Total: {currency(total, {symbol: '', precision: 0}).format()}</span>
            <span className="mr-2">Pending: {currency(stats.pending, {symbol: '', precision: 0}).format()}</span>
            <span className="mr-2 text-success">Completed: {currency(stats.completed, {symbol: '', precision: 0}).format()}</span>
            <span className="mr-2 text-danger">Failed: {currency(stats.failed, {symbol: '', precision: 0}).format()}</span>
          </div>
        </div>
        <div className="col-md-6">
          <div className="text-right mb-4 my-2">
              <span
                title="Check Status"
                className="mr-2"
                style={{cursor: 'pointer', color: '#0097FE'}}
                onClick={checkStatus}
              ><i className={`fas fa-sync${statusCheck ? ' fa-spin' : ''}`}></i></span> Cron Action <Badge as="span" className={`badge-${status == 0 ? 'success' : (status == 1 ? 'warning' : (status == 2 ? 'danger' : 'secondary'))}`}>
              {status == 0 ? 'Waiting' : (status == 1 ? 'Processing' : (status == 2 ? 'Error' : 'Off'))}
            </Badge>
            <span className="mx-2">Cron Status</span> <Form.Check
              inline
              type="switch"
              id="custom-switch"
              title="Cron Status"
              label={status == 3 ? 'Off' : 'On'}
              checked={status == 3 ? false : true}
              disabled={isLoading}
              onChange={() => setShow(show => !show)}
            />
          </div>
        </div>
      </div>
      
      <div className="row">
        <div className="col-md-6">
          <form className="form-inline" onSubmit={e => e.preventDefault()}>
            <div className="form-group mt-3" style={{flexFlow: 'unset', display: 'flex'}}>
              <input
                type="text"
                className={`form-control form-control-sm mr-3 keyword ${keyword ? 'mr-0' : ''}`}
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
              />
              {
                keyword && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
              }
              <button
                type="button"
                className="btn btn-primary btn-sm"
                disabled={isSearching}
                onClick={getPriceChange}
                style={{padding: '3px 8px', width: 'auto'}}
              >{ isSearching ? 'Searching...' : 'Search'}</button>
            </div>

            <div className="filters ml-3 mr-2 form-group mt-3">
              <span className="mr-2">Filters:</span> <Form.Check
                        inline
                        type="switch"
                        id="filterCompleted"
                        label="completed"
                        value="1"
                        onChange={handleSwitchChange}
                        checked={!!filters[1]}
                      />
                      <Form.Check 
                        inline
                        type="switch"
                        id="filterPending"
                        label="pending"
                        value="0"
                        onChange={handleSwitchChange}
                        checked={filters[0]}
                      />
                      <Form.Check 
                        inline
                        type="switch"
                        id="filterFailed"
                        label="failed"
                        value="2"
                        onChange={handleSwitchChange}
                        checked={filters[2]}
                      />
            </div>
          </form>
          
          
        </div>
        <div className="col-md-6">
          <div className="my-3">
            <Paginator />
          </div>
        </div>
      </div>

      { isLoading && <div className="my-2">
        <Spinner variant="primary" size="sm" animation="border" /> Getting latest data...
      </div>}

      <table className="table table-condensed table-bordered table-sm table-striped table-responsive">
        <thead>
          <tr>
            <th>
              <a href="#" onClick={e => handleOrder(e, 'id')}>
                <span style={{ color: "black" }}>ID 
                    {orderBy == 'id' && (
                        <FontAwesomeIcon
                            className="ml-2"
                            color="#0097FE"
                            icon={[
                                "fas",
                                sort === "desc"
                                    ? "chevron-down"
                                    : "chevron-up",
                            ]} />
                    )}
                </span>
              </a>
            </th>
            <th>
              <a href="#" onClick={e => handleOrder(e, 'user_id')}>
                <span style={{ color: "black" }}>PU ID 
                    {orderBy == 'user_id' && (
                        <FontAwesomeIcon
                            className="ml-2"
                            color="#0097FE"
                            icon={[
                                "fas",
                                sort === "desc"
                                    ? "chevron-down"
                                    : "chevron-up",
                            ]} />
                    )}
                </span>
              </a>
            </th>
            <th>
              <a href="#" onClick={e => handleOrder(e, 'users.login')}>
                <span style={{ color: "black" }}>PU
                  {orderBy == 'users.login' && (
                    <FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            "fas",
                            sort === "desc"
                                ? "chevron-down"
                                : "chevron-up",
                        ]} />
                  )}
                </span>
              </a>
            </th>
            
            <th>
              <a href="#" onClick={e => handleOrder(e, 'creators.subscription_price')}>
                <span style={{ color: "black" }}>Active Price 
                  {orderBy == 'creators.subscription_price' && (
                    <FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            "fas",
                            sort === "desc"
                                ? "chevron-down"
                                : "chevron-up",
                        ]} />
                  )}
                </span>
              </a>
            </th>

            <th>
              <a href="#" onClick={e => handleOrder(e, 'old_price')}>
                <span style={{ color: "black" }}>Old Price 
                  {orderBy == 'old_price' && (
                    <FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            "fas",
                            sort === "desc"
                                ? "chevron-down"
                                : "chevron-up",
                        ]} />
                  )}
                </span>
              </a>
            </th>
            
            <th>
              <a href="#" onClick={e => handleOrder(e, 'new_price')}>
                <span style={{ color: "black" }}>New Price 
                  {orderBy == 'new_price' && (
                    <FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            "fas",
                            sort === "desc"
                                ? "chevron-down"
                                : "chevron-up",
                        ]} />
                  )}
                </span>
              </a>
            </th>
            <th>
              <a href="#" onClick={e => handleOrder(e, 'status')}>
                <span style={{ color: "black" }}>Status 
                  {orderBy == 'status' && (
                    <FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            "fas",
                            sort === "desc"
                                ? "chevron-down"
                                : "chevron-up",
                        ]} />
                  )}
                </span>
              </a>
            </th>
            <th>
              <a href="#" onClick={e => handleOrder(e, 'date')}>
                <span style={{ color: "black" }}>Date Added 
                  {orderBy == 'date' && (
                    <FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            "fas",
                            sort === "desc"
                                ? "chevron-down"
                                : "chevron-up",
                        ]} />
                  )}
                </span>
              </a>
            </th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {
            priceChanges.length > 0 && priceChanges.map(priceChange => (
              <tr key={priceChange.id} className={busyRow == priceChange.id ? 'table-active table-busy' : ''}>
                <td>{priceChange.id}</td>
                <td>{priceChange.user_id}</td>
                <td>{priceChange.login ? priceChange.login : 'Removed User'}</td>
                <td>{currency(priceChange.subscription_price ?? 0).format()}</td>
                <td>{currency(priceChange.old_price).format()}</td>
                <td>{currency(priceChange.new_price).format()}</td>
                <td>{priceChange.status == 0 ? 'pending' : (priceChange.status == 1 ? 'completed' : 'failed')}</td>
                <td>{ priceChange.date ? moment.utc(priceChange.date).local().format('lll') : '' }</td>
                <td>
                  {
                    <span
                      style={{ color: "black", cursor: 'pointer' }}
                      onClick={(e) => handleConfirmDelete(e, priceChange)}
                      title="Delete"
                    ><FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            'fas',
                            'trash',
                        ]} />
                    </span>
                  }
                  {
                    priceChange.status == 2 && <span
                      style={{ color: "black", cursor: 'pointer' }}
                      onClick={(e) => handleResend(e, priceChange)}
                      title="Reprocess"
                      ><FontAwesomeIcon
                        className="ml-2"
                        color="#0097FE"
                        icon={[
                            'fas',
                            'redo',
                        ]} />
                    </span>
                  }
                </td>
              </tr>
            ))
          }

          {
            priceChanges.length <= 0 && !isLoading && <tr>
              <td colSpan={8}>No price change to process</td>
            </tr>
          }
        </tbody>
      </table>

      <div className="mt-3 mb-3">
        <Paginator />
      </div>

      <AlertConfirmModal
        modalBody={`Are you sure you want to turn ${status == 3 ? 'on' : 'off'} the cron?`}
        show={show}
        setShow={setShow}
        isConfirm={true}
        useFunction={handleConfirm}
        busy={isLoading}
      />

      <AlertConfirmModal
        modalBody={`Are you sure you want to delete the mail?`}
        show={showDelete}
        setShow={setShowDelete}
        isConfirm={true}
        useFunction={handleDelete}
        busy={isLoading}
      />
    </div>
  )
}

export default PriceChanges